(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('material-ibq', {
            parent: 'entity',
            url: '/material-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.material.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material/materialsibq.html',
                    controller: 'MaterialIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('material');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('material-ibq-detail', {
            parent: 'material-ibq',
            url: '/material-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.material.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material/material-ibq-detail.html',
                    controller: 'MaterialIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('material');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Material', function($stateParams, Material) {
                    return Material.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'material-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('material-ibq-detail.edit', {
            parent: 'material-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-dialog.html',
                    controller: 'MaterialIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Material', function(Material) {
                            return Material.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-ibq.new', {
            parent: 'material-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-dialog.html',
                    controller: 'MaterialIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                subtitle: null,
                                editionNumber: null,
                                pages: null,
                                isbn: null,
                                description: null,
                                editionYear: null,
                                coverFile: null,
                                coverFileContentType: null,
                                coverPath: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('material-ibq', null, { reload: 'material-ibq' });
                }, function() {
                    $state.go('material-ibq');
                });
            }]
        })
        .state('material-ibq.edit', {
            parent: 'material-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-dialog.html',
                    controller: 'MaterialIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Material', function(Material) {
                            return Material.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-ibq', null, { reload: 'material-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-ibq.delete', {
            parent: 'material-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-delete-dialog.html',
                    controller: 'MaterialIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Material', function(Material) {
                            return Material.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-ibq', null, { reload: 'material-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
